import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ settings: null });
export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api
      .get("/site/settings")
      .then(({ data }) => setSettings(data))
      .catch(() => setSettings(null));
  }, []);
  return <SiteContext.Provider value={{ settings }}>{children}</SiteContext.Provider>;
}
